import React, { useEffect, useState } from 'react';
import { Home, Grid3X3, ShoppingCart, Heart, User } from 'lucide-react';
import '../assets/BottomNavigation.css';
import { useLocation } from 'react-router-dom';
import { navItems } from '../constant/bottomNav';

const BottomNavigation = () => {
  const [activeTab, setActiveTab] = useState(3);
  const location = useLocation(); // گرفتن مسیر فعلی

  useEffect(() => {
    const activeItem = navItems.find((item) => item.link === location.pathname);
    if (activeItem) {
      setActiveTab(activeItem.id);
    }
  }, [location]);
  return (
    <nav className='bottom-nav-profile'>
      <div className='nav-container-profile'>
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;

          return (
            <a key={item.id} onClick={() => setActiveTab(item.id)} className={`nav-item-profile ${isActive ? 'active-profile' : ''}`} href={item.link}>
              <Icon size={20} className={`nav-icon-profile ${isActive ? 'active-profile' : ''}`} />
              <span className={`nav-title-profile ${isActive ? 'active-profile' : ''}`}>{item.title}</span>
            </a>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
